"use client";

import Link from "next/link";
import { LinkType } from "../../../sanity/lib/types/link";
import { LocalizedLink } from "./localizedLink";

export const LinkElement = ({
    link,
    type,
    id,
    className,
    size,
}: {
    link: LinkType;
    type?: string;
    id?: string;
    className?: string;
    size?: string;
}) => {
    const sizeClass =
        size === "small"
            ? "m-button-small md:d-button-small px-6 py-3"
            : "m-button md:d-button px-4 py-2 md:py-3 md:px-6";
    const iconSize = size === "small" ? "w-6 h-6" : "w-5 h-5 lg:w-8 lg:h-8";

    if (!link) {
        return null;
    }

    if (link.type === "external") {
        return (
            <Link
                href={link.external ?? ""}
                className={`relative flex items-center gap-2 border border-black rounded-full ${sizeClass} ${className}`}
                target="_blank"
                rel="noopener noreferrer"
                id={id}
            >
                {link.label}

                <svg
                    className={iconSize}
                    width="36"
                    height="37"
                    viewBox="0 0 36 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.5006 6.875H29.6256V21.7812H27.3756V10.716L8.29607 29.7955L6.70508 28.2045L25.7846 9.125H13.5006V6.875Z"
                            fill="black"
                        />
                    </g>
                </svg>
            </Link>
        );
    }

    const label = (
        <>
            {link.label}

            <svg
                className={iconSize}
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.5006 6.875H29.6256V21.7812H27.3756V10.716L8.29607 29.7955L6.70508 28.2045L25.7846 9.125H13.5006V6.875Z"
                        fill="black"
                    />
                </g>
            </svg>
        </>
    );

    return (
        <LocalizedLink
            slug={link.internal?.metadata.slug.current ?? ""}
            id={id}
            className={`relative flex items-center gap-2 border border-black rounded-full ${sizeClass} ${className}`}
            label={label}
        />
    );
};
